function bisNonSize(productVariants, productTags) {
  productVariants.forEach(function(variant) {
    var productAvailable = variant.available;
    //Hide the back in stock - notify me button
    //for non size products
    if ((variant.option2 === null && productAvailable) || (variant.option2 === null && !productAvailable)) {
      $(".bis-product").hide();
    }
  });

  productTags.forEach(function(tag) {
    var bisPreOrder = tag.indexOf("bis-preorder") > -1;
    var bisHidden = tag.indexOf("bis-hidden") > -1;

    if (bisPreOrder) {
      $(".bis-product").show();
    }

    if (bisHidden) {
      $(".bis-product").hide();
    }
  });
}
